import { AvailableProviders } from './availableProviders'

export const LISTINGS_PROVIDERS = [
  AvailableProviders.ABLocal,
  AvailableProviders.Acompio,
  AvailableProviders.Alexa,
  AvailableProviders.AllMenus,
  AvailableProviders.AmericanExpress,
  AvailableProviders.AmericanTowns,
  AvailableProviders.Apple,
  AvailableProviders.AroundMe,
  AvailableProviders.BetterBusinessBureau,
  AvailableProviders.Bing,
  AvailableProviders.Brave,
  AvailableProviders.Brownbook,
  AvailableProviders.BrunchLunchDinner,
  AvailableProviders.CentralIndex,
  AvailableProviders.ChamberOfCommerce,
  AvailableProviders.Citysearch,
  AvailableProviders.CitySquares,
  AvailableProviders.Cylex,
  AvailableProviders.Doordash,
  AvailableProviders.DunAndBradstreet,
  AvailableProviders.EightCoupons,
  AvailableProviders.eLocal,
  AvailableProviders.EZlocal,
  AvailableProviders.Facebook,
  AvailableProviders.Foursquare,
  AvailableProviders.GoLocal247,
  AvailableProviders.Google,
  AvailableProviders.Help,
  AvailableProviders.Here,
  AvailableProviders.HostMe,
  AvailableProviders.HotFrog,
  AvailableProviders.HoursCom,
  AvailableProviders.iBegin,
  AvailableProviders.iGlobal,
  AvailableProviders.Infobel,
  AvailableProviders.InfoIsInfo,
  AvailableProviders.InsiderPages,
  AvailableProviders.Instacart,
  AvailableProviders.InYourArea,
  AvailableProviders.Koomio,
  AvailableProviders.Local,
  AvailableProviders.LocalDatabase,
  AvailableProviders.LocalStack,
  AvailableProviders.Mapbox,
  AvailableProviders.MapQuest,
  AvailableProviders.Mapstr,
  AvailableProviders.Menupix,
  AvailableProviders.MerchantCircle,
  AvailableProviders.MoneyMailer,
  AvailableProviders.MyLocalServices,
  AvailableProviders.N49,
  AvailableProviders.Navmii,
  AvailableProviders.Nextdoor,
  AvailableProviders.Oeffnungszeitenbuch,
  AvailableProviders.OneNineTwo,
  AvailableProviders.OpenAI,
  AvailableProviders.Opendi,
  AvailableProviders.OpenTable,
  AvailableProviders.Ourbis,
  AvailableProviders.Pages24,
  AvailableProviders.PitneyBowes,
  AvailableProviders.ProfileCanada,
  AvailableProviders.PropertyCapsule,
  AvailableProviders.QuinceaneraCom,
  AvailableProviders.RexDirect,
  AvailableProviders.SafeGraph,
  AvailableProviders.SeccionAmarilla,
  AvailableProviders.ShowMeLocal,
  AvailableProviders.Snapchat,
  AvailableProviders.Soleo,
  AvailableProviders.Stadtbranchenbuch,
  AvailableProviders.Tellows,
  AvailableProviders.TikTok,
  AvailableProviders.TomTom,
  AvailableProviders.TopRatedLocal,
  AvailableProviders.TripAdvisor,
  AvailableProviders.Tupalo,
  AvailableProviders.TwoFindLocal,
  AvailableProviders.Uber,
  AvailableProviders.UberEats,
  AvailableProviders.USCity,
  AvailableProviders.WhereTo,
  AvailableProviders.Winnie,
  AvailableProviders.wogibtswas,
  AvailableProviders.Yahoo,
  AvailableProviders.Yalwa,
  AvailableProviders.Yandex,
  AvailableProviders.YaSabe,
  AvailableProviders.Yell,
  AvailableProviders.YellowMoxie,
  AvailableProviders.YellowPageCity,
  AvailableProviders.YellowPages,
  AvailableProviders.YellowPagesCanada,
  AvailableProviders.YellowPagesDirectory,
  AvailableProviders.Yelp,
  AvailableProviders.ZipLocalOnline,
] as const
export type ListingsProvidersType = (typeof LISTINGS_PROVIDERS)[number]
